import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Container, Row, Col } from '../../../../../SPRINTA/atoms/Grid'
import Font from '../../../../../SPRINTA/atoms/Font'
import Loading from '../../../../../SPRINTA/atoms/Loading'
import Placeholder from '../../../../../SPRINTA/atoms/PlaceHolder'
import FollowUser from '../../../../../SPRINTA/molecules/FollowUser'
import * as user from '../../../../utils/user'
import Button from '../../../../../SPRINTA/atoms/Button'
import T from '../../../../../SPRINTA/translate/T'

class Follow extends Component {
   state = {
      loading: true,
      data: [],
      total: 0,
      loadingMore: false
   }

   componentWillMount() {
      this.componentWillReceiveProps(this.props, true)   
   }

   componentWillReceiveProps(nextProps, force = false) {
      if(this.props.username !== nextProps.username || this.props.type !== nextProps.type || force || nextProps.type !== this.props.type) {
            this.loadData(nextProps.username, nextProps.type, 0)
            this.setState({
                  loading: true,
                  data: []
            })
      }
   }

   loadData(username, type, start = 0, limit = 16) {
      this.setState({
            loadingMore: true
      })

      user.follow(username, type, start, limit)
      .then(data => {
         this.setState({
            loading: false,
            total: data.result.total,
            data: [
                  ...this.state.data,
                  ...data.result.list
            ],
            loadingMore: false
         })
      })
   }

   loadMoreData() {
      this.setState({
            loadingMore: true
      })

      this.loadData(this.props.username, this.props.type, this.state.data.length)
   }

   toggleFollow(item) {
      user.toggleFollow(item.id, item.iFollow ? 'unfollow' : 'follow')
      let idx = this.state.data.indexOf(item)
      let data = this.state.data
      item.iFollow = !item.iFollow
      data[idx] = item
      this.setState({
            data
      })
   }


   render() {
      if(this.state.loading)
      return(
         <Container>
            <Row>
               <Col>
                  <Placeholder type='retangle' style={{width: '200px', marginTop: '20px', height: '40px'}} />
                  <Row>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                     <Col size='6 3'>
                        <Placeholder type='retangle' style={{marginTop: '20px', height: '120px'}} />
                     </Col>
                  </Row>
                  <br />
               </Col>
            </Row>
         </Container>
      )

      return (
         <Container style={{paddingBottom: '30px'}}>
            <Row>
               <Col>
                  <Font heading="3" color='#666' weight='100' style={{margin: '30px 0'}}>
                     {this.props.type === 'following' ? T.txt('following') : T.txt('followers')} <b>({this.state.total})</b>
                  </Font>
                  <Row>
                        {this.state.data.map(item => (
                              <Col size='6 3' key={item.id}>
                                    <FollowUser
                                          showBtn={this.props.user.userData ?  true : false}
                                          action={() => { 
                                                this.toggleFollow(item)
                                          }}
                                          following={item.iFollow}
                                          label={item.iFollow ? T.txt('unfollow') : T.txt('follow')}
                                          user={{
                                                avatar: item.avatarPath,
                                                name: item.name,
                                                href: `/user/${item.username || item.token}`,
                                          }}
                                    />
                              </Col>
                        ))}
                  </Row>
                  {this.state.data.length < this.state.total && (
                        <Col text='center'>
                              {!this.state.loadingMore ? (
                                    <Button
                                    inline
                                    theme='primary'
                                    onClick={() => this.loadMoreData()}>
                                          {T.txt('load_more')}
                                    </Button>
                              ) : (
                                    <Loading />    
                              )}
                        </Col>
                  )}
               </Col>
            </Row>
         </Container>
      )
   }
}

const mapStateToProps = store => ({
   user: store.user
})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Follow)


// WEBPACK FOOTER //
// ./src/App/pages/Profile/Pages/Follow/index.js